import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, ArrowLeft, Home } from "lucide-react";

export const ToolLayout = ({ title, subtitle, icon: Icon, accent = "#2D6A4F", children }) => (
  <div className="min-h-screen aura-grain">
    <header className="sticky top-0 z-40 border-b border-[#E8E3D9] bg-[#FBF9F5]/85 backdrop-blur-md">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-y-3 px-4 sm:px-6 lg:px-10 py-3.5">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-home-link">
          <div className="h-9 w-9 rounded-xl bg-[#1E2B25] flex items-center justify-center shadow-sm">
            <Sparkles className="h-4.5 w-4.5 text-[#D99B26]" strokeWidth={2.2} />
          </div>
          <div className="leading-tight">
            <h1 className="font-heading text-lg font-extrabold tracking-tight text-[#1A231F]">My Finanz Planner</h1>
            <p className="hidden sm:block text-[10px] text-[#8A9790] font-medium leading-snug max-w-[260px]">Personal Finance Tools &amp; Calculators to plan, grow and streamline your personal finance journey</p>
          </div>
        </Link>
        <div className="flex items-center gap-2 sm:gap-3">
          <Link to="/" data-testid="home-btn" aria-label="Home"
            className="flex items-center justify-center h-10 w-10 rounded-xl bg-white border border-[#E8E3D9] text-[#1E2B25] hover:bg-[#1E2B25] hover:text-white shadow-sm transition-colors">
            <Home className="h-5 w-5" />
          </Link>
          <Link to="/" data-testid="all-tools-link"
            className="flex items-center gap-2 rounded-full bg-[#1E2B25] text-white px-4 sm:px-5 h-10 text-sm sm:text-base font-bold shadow-sm hover:bg-[#2b3d34] transition-colors">
            <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5" /> All Tools
          </Link>
        </div>
      </div>
    </header>

    <div className="border-b border-[#E8E3D9]" style={{ background: accent }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-8 sm:py-10">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
          className="flex items-center gap-4">
          <div className="h-12 w-12 rounded-2xl bg-white/15 flex items-center justify-center backdrop-blur">
            {Icon && <Icon className="h-6 w-6 text-white" strokeWidth={2} />}
          </div>
          <div>
            <h2 className="font-heading text-2xl sm:text-3xl font-extrabold text-white tracking-tight">{title}</h2>
            <p className="text-white/75 text-sm sm:text-base mt-0.5">{subtitle}</p>
          </div>
        </motion.div>
      </div>
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-6 sm:py-10">{children}</div>

    <footer className="border-t border-[#E8E3D9] py-6 text-center">
      <p className="text-xs text-[#8A9790]">My Finanz Planner · Estimates are illustrative, not financial advice.</p>
    </footer>
  </div>
);

export const TwoCol = ({ left, right }) => (
  <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
    <div className="lg:col-span-5 space-y-6">{left}</div>
    <div className="lg:col-span-7 space-y-6">{right}</div>
  </div>
);
